import { render, staticRenderFns } from "./RotationalMenus.vue?vue&type=template&id=83d07f20"
import script from "./RotationalMenus.vue?vue&type=script&lang=ts"
export * from "./RotationalMenus.vue?vue&type=script&lang=ts"
import style0 from "./RotationalMenus.vue?vue&type=style&index=0&id=83d07f20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports